import { extractDESLErrorAttributes } from '@sparknz/journeys-common';
import { trackDigitalEvent } from '@sparknz/tracking';

import { buildTrackingCartData } from 'shared/utils/tracking/buildTrackingCartData.utils';
import { EventInfo, LinkedProductsTrackingArgs } from '../typings';
import { constructAnalyticsProduct } from './constructAnalyticsProduct';

export function trackLinkedProductsEvent({
  cart,
  device,
  eventInfo,
  plan,
  paymentOption,
  isBusiness,
  isChangePlan,
  isSpotifyOptIn,
}: LinkedProductsTrackingArgs) {
  trackDigitalEvent({
    event: eventInfo.eventAction,
    w3cddl: {
      event: [
        {
          eventInfo,
          attributes: {
            isSuccess: true,
          },
        },
      ],
      cart:
        cart &&
        buildTrackingCartData({
          cart,
          isBusiness,
        }),
      product: [
        constructAnalyticsProduct({
          device,
          eventInfo,
          plan,
          paymentOption,
          isBusiness,
          isChangePlan,
          isSpotifyOptIn,
        }),
      ],
    },
  });
}

interface LinkedProductsErrorTrackingArgs {
  error: Error;
  eventInfo: EventInfo;
}

export function trackLinkedProductsEventError({
  error,
  eventInfo,
}: LinkedProductsErrorTrackingArgs) {
  const sanitisedError = extractDESLErrorAttributes(error);

  trackDigitalEvent({
    event: eventInfo.eventAction,
    w3cddl: {
      event: [
        {
          eventInfo,
          attributes: {
            isSuccess: false,
            internalErrorCode: sanitisedError?.code?.toString(),
            internalErrorMessage: sanitisedError?.message,
            errorMessage: sanitisedError?.message || error?.message,
          },
        },
      ],
    },
  });
}

export function trackProdViewActionError(error: Error) {
  trackLinkedProductsEventError({
    error,
    eventInfo: {
      eventName: 'Product View',
      eventAction: 'shop.prodViewAction',
    },
  });
}
